<template>
	<div>
		<buttonlist @help="help" @search="search" @reflash="reflash" ref="SetBtn"></buttonlist>
		<el-button style="margin-top: 2px" type="primary" size="mini" :disabled="selectData.length != 1" @click.native.prevent="createMRB">{{$t('getapi[8512]')}}</el-button>
		<el-table
				id="xpane-0"
				:data="dataSet"
				v-loading="loading"
				:highlight-current-row="true"
				show-overflow-tooltip="true"
				border
				stripe
				size="mini"
				:height="tableHeight"
				header-row-class-name="headerclass"
				style="width: 100%; margin-top:0px"
				:header-cell-style="$limits.headerClass"
				@selection-change="handleSelectionChange"
				ref="singleTable"
		>
			<el-table-column type="selection"></el-table-column>
			<el-table-column show-overflow-tooltip prop="so_code" :label="$t('getapi[4168]')" sortable></el-table-column>
			<el-table-column show-overflow-tooltip prop="routing_sequence_no" :label="$t('getapi[573]')" sortable></el-table-column>
			<el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')" sortable></el-table-column>
			<el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')" sortable></el-table-column>
			<el-table-column prop="Report_Qty" :label="$t('getapi[4905]')" sortable align="right">
				<template slot-scope="scope">
					{{scope.row.Report_Qty | thousandth}}
				</template>
			</el-table-column>
			<el-table-column prop="Scrap_qty" :label="$t('getapi[4220]')" sortable align="right">
				<template slot-scope="scope">
					{{scope.row.Scrap_qty | thousandth}}
				</template>
			</el-table-column>
			<el-table-column prop="rework_qty" :label="$t('getapi[4906]')" sortable align="right">
				<template slot-scope="scope">
					{{scope.row.rework_qty | thousandth}}
				</template>
			</el-table-column>
			<el-table-column show-overflow-tooltip prop="Workcenter_code" :label="$t('getapi[4361]')" sortable></el-table-column>
			<el-table-column show-overflow-tooltip prop="Workcenter_name" :label="$t('getapi[882]')" sortable></el-table-column>
			<el-table-column prop="Report_ManHour" :label="$t('getapi[4907]')" sortable align="right">
				<template slot-scope="scope">
					{{scope.row.Report_ManHour | thousandth}}
				</template>
			</el-table-column>
			<el-table-column show-overflow-tooltip prop="Report_Man" :label="$t('getapi[4908]')" sortable></el-table-column>
			<el-table-column show-overflow-tooltip prop="Report_time" :label="$t('getapi[4909]')" sortable></el-table-column>
			<el-table-column show-overflow-tooltip prop="item_code" :label="$t('getapi[876]')" sortable></el-table-column>
			<el-table-column show-overflow-tooltip prop="item_name" :label="$t('getapi[1503]')" sortable></el-table-column>
			<el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[143]')" sortable></el-table-column>
			<el-table-column show-overflow-tooltip prop="Workproc_name" :label="$t('getapi[574]')" sortable></el-table-column>
			<el-table-column show-overflow-tooltip prop="Routing_desc" :label="$t('getapi[575]')" sortable></el-table-column>
			<el-table-column prop="Review_Qty" :label="$t('getapi[7130]')" sortable align="right">
				<template slot-scope="scope">
					{{scope.row.Review_Qty | thousandth}}
				</template>
			</el-table-column>
			<el-table-column show-overflow-tooltip prop="flag" :label="$t('getapi[552]')" sortable></el-table-column>
			<el-table-column show-overflow-tooltip prop="MRBRemark" :label="$t('getapi[8525]')" sortable></el-table-column>
		</el-table>
		<el-row class="page">
				<el-col :span="18">
					<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:page-sizes="[100, 200, 300, 400]"
						:page-size="pageSize"
						:pager-count="5"
						layout="total, sizes, prev, pager, next, jumper"
						:total="total"
					></el-pagination>
				</el-col>
				<el-col :span="6">
					<div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
				</el-col>
			</el-row>
		<!-- 改变表格顺序 -->
		<ctable :isVisible="false" :title="$t('getapi[8524]')" queryData="ProDirectReportViewInfo" tabNo="0" ref="ctab" @getctab="sortclick"></ctable>
	
		<serce :isVisible="isVisible" queryData="ProDirectReportViewInfo" ref="ser" @getser="serclick"></serce>
	</div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
export default {
	name:'mrbreportlist',
    computed: {
        tableOption() {
            return {
                border: true,
                height: this.$windowSize.tableHeight3-Common.reduceTableHeight3,
                maxHeight: this.$windowSize.tableHeight3-Common.reduceTableHeight3,
            }
        },
        tableHeight(){
            return this.$windowSize.tableHeight3 - Common.reduceTableHeight3
        }
    },
	data() {
		return {
			dataSet: [], // 主表数据
			isVisible: false, // 查询列表是否显示
			queryData: [], // 查询数组
			userData: [], // 用户信息
			DbTbNames: '',
			pageIndex: 1, // 当前页
			pageSize: this.$http.getPageSize('mrbreportlist'), // 当前页数据量
			SelectIndexs: 1, //当前页面
			total: 0, // 数据总量
			loading: false, // 主表加载状态
			tableHeader: [],
            selectData:[],
            scrollTop:0,
		};
	},
	mounted: function() {
		let that = this;
		that.userData = sessionStorage.getItem('userData');
		that.PlanTypeArray = Array.methods.getPlanType();
		that.authority();
		that.colsort();
        that.$nextTick(function(){
            that.$processdata.initForm()
        });
	},
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })
    },
	methods: {
		colsort(){
			let that = this;
			that.$loadviewfields.Fileds('ProDirectReportViewInfo',0,PFileds=>{
			that.tableHeader = PFileds;
		});	
		},
		sortclick(val){
			if(val==1){
				this.colsort();
			}
		},
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[8524]"),this.$t("getapi[8513]"));
        },
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
            that.$refs.SetBtn.SetButtonEnable('search,refresh');
		},
		handleSizeChange(val) {
			this.pageSize = val;
            this.$http.savePageSize('mrbreportlist',val)
			this.getView();
			this.authority();
		},
		handleCurrentChange(val) {
			this.pageIndex = val;
			this.getView();
			this.authority();
		},
		// 查询
		search() {
			let that = this;
			that.isVisible = true;
			that.$refs.ser.clearInput(that.isVisible, 'ProDirectReportViewInfo');
		},
		// 修改表格顺序
		opentable(){
			this.$refs.ctab.clearInputs(true);
		},
		//获取查询条件
		serclick(val) {
			this.queryData = val;
			this.confirmGetView();
		},
		// 确认获取数据
		confirmGetView() {
			let that = this;
            that.pageIndex = 1
			that.isVisible = false;
			that.getView();
		},
		// 数据一览
		getView() {
			let that = this;
			that.loading = true;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let token = JSON.parse(that.userData).token;
			let data = {
				PageIndex: that.pageIndex,
				PageSize: that.pageSize,
				SelectIndex: that.SelectIndexs,
				Param: datac
			};
			that.$http.urlpost('/MRB/ReportList', data, function(res) {
				if (res.Success == 1) {
					that.dataSet = res.DataContent;
					that.total = res.Totals;
					that.loading = false;
					that.DbTbNames = res.DbTbNames;
					that.authority();
                    that.$nextTick(function(){
                        that.$processdata.initForm(0)
                    });
				} else {
					that.$message.error(res.Msg);
				}
			});
		},
		// 刷新
		reflash() {
			let that = this;
			that.getView();
		},
        handleSelectionChange(val){
            let that = this;
            that.selectData = [];
            for (let i = 0; i < val.length; i++) {
                that.selectData.push(val[i]);
            }
		},
        createMRB(){
            let that = this
            if(!this.$limits.menuvisible("plv2", 593, 1)){
                return
            }
            let arr = []
            for(let i = 0;i<that.selectData.length;i++){
                arr = [...arr,{
                    exclusively_id: that.selectData[i].exclusively_id
                }]
            }
            that.$store.commit('setSharedParams', {
                ls: arr
			});
            let item = {
                label: this.$t("getapi[8508]"),
                name: 'mrbview',
                path: '/mrbview',
                url: '/mrbview',
                icon: 'video-play'
            };
            this.$router.push({ path: '/mrbview'});
            this.$store.commit('selectMenu', item);
            this.$limits.cachePage(item)
            /*that.$http.urlpost('/MRB/GetMrbInfoByRportNum', parm, function (res) {
                if (res.Success == 1) {
                    that.$message.success(res.Msg)
                }
            });*/
        }
	}
};
</script>

<style scoped lang="less">
table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}
</style>
